module.exports = __webpack_public_path__ + "img/Icon_mail2.af136c08.svg";